import { render, staticRenderFns } from "./BrRetrospectUse.vue?vue&type=template&id=358c23fa&scoped=true"
import script from "./BrRetrospectUse.vue?vue&type=script&lang=js"
export * from "./BrRetrospectUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c23fa",
  null
  
)

export default component.exports